"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nomeMask = exports.onlyNumber = exports.codeConfirmationMask = exports.documentoMask = exports.cepMask = exports.percentMask = exports.currencyMask = exports.moneyMask = exports.telefoneMask = exports.celularMask = exports.telefoneCelularMask = exports.cnpjMask = exports.cpfMask = void 0;
const round_to_1 = __importDefault(require("round-to"));
const cpfMask = (value) => value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
exports.cpfMask = cpfMask;
const cnpjMask = (value) => {
    if (!value) {
        return '';
    }
    return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
};
exports.cnpjMask = cnpjMask;
const telefoneCelularMask = (v) => {
    if (!v) {
        return '';
    }
    let r = v.replace(/\D/g, '');
    r = r.replace(/^0/, '');
    if (r.length > 10) {
        r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
    }
    else if (r.length > 6) {
        r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, '($1) $2-$3');
    }
    else if (r.length > 2) {
        r = r.replace(/^(\d\d)(\d{0,5})/, '($1) $2');
    }
    else {
        r = r.replace(/^(\d*)/, '($1');
    }
    return r;
};
exports.telefoneCelularMask = telefoneCelularMask;
const celularMask = (value) => !value
    ? ''
    : value
        .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
        .replace(/(\d{2})(\d)/, '($1)$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{4})\d+?$/, '$1');
exports.celularMask = celularMask;
const telefoneMask = (value) => value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '($1)$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
exports.telefoneMask = telefoneMask;
const moneyMask = (valor) => {
    let valorSemPontoVirgula;
    if (Number.isInteger(valor)) {
        valorSemPontoVirgula = `${valor}.00`;
    }
    else {
        valorSemPontoVirgula = `${valor}`;
    }
    const casaDecimal = valorSemPontoVirgula.split('.')[1] || '00';
    if (casaDecimal.length < 2) {
        valorSemPontoVirgula = `${valor}0`;
    }
    else if (Number(casaDecimal) > 2) {
        valorSemPontoVirgula = `${valor.toFixed(2)}`;
    }
    return valorSemPontoVirgula
        .replace(/\D/g, '') // permitea digitar apenas numero
        .replace(/(\d)(\d{23})$/, '$1.$2')
        .replace(/(\d)(\d{20})$/, '$1.$2')
        .replace(/(\d)(\d{17})$/, '$1.$2')
        .replace(/(\d)(\d{14})$/, '$1.$2') // coloca ponto antes dos ultimos digitos
        .replace(/(\d)(\d{11})$/, '$1.$2') // coloca ponto antes dos ultimos 11 digitos
        .replace(/(\d)(\d{8})$/, '$1.$2') // coloca ponto antes dos ultimos 8 digitos
        .replace(/(\d)(\d{5})$/, '$1.$2') // coloca ponto antes dos ultimos 5 digitos
        .replace(/(\d)(\d{1,2})?$/, '$1,$2'); // ;
};
exports.moneyMask = moneyMask;
const currencyMask = (valor) => {
    return valor ? `R$ ${exports.moneyMask(valor)}` : '';
};
exports.currencyMask = currencyMask;
const percentMask = (valor, casasDecimais = 2) => {
    let valorNormalizado;
    if (Number.isInteger(valor)) {
        valorNormalizado = `${valor}00`;
    }
    else if (Number.isFinite(valor)) {
        const valorMultiplicado = round_to_1.default(valor * 100, 2);
        valorNormalizado = `${valorMultiplicado}`;
    }
    else {
        valorNormalizado = `${valor}`;
    }
    valorNormalizado = valorNormalizado.replace(/\D/g, '');
    let reAntesVirgula;
    if (valorNormalizado.length - casasDecimais > 1) {
        reAntesVirgula = new RegExp('(\\d{2})(\\d)');
    }
    else {
        reAntesVirgula = new RegExp('(\\d)(\\d)');
    }
    return valorNormalizado
        .replace(reAntesVirgula, '$1,$2')
        .replace(new RegExp(`(,\\d{${casasDecimais}})\\d+?`), '$1');
};
exports.percentMask = percentMask;
const cepMask = (value) => {
    if (!value) {
        return value;
    }
    return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1-$2')
        .replace(/(-\d{3})\d+?$/, '$1');
};
exports.cepMask = cepMask;
const documentoMask = (doc) => {
    let docFmt = doc.replace(/\D/g, '');
    if (docFmt.length > 11) {
        docFmt = exports.cnpjMask(docFmt);
    }
    else {
        docFmt = exports.cpfMask(docFmt);
    }
    return docFmt;
};
exports.documentoMask = documentoMask;
const codeConfirmationMask = (value) => value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');
exports.codeConfirmationMask = codeConfirmationMask;
const onlyNumber = (value) => value.replace(/\D/g, '');
exports.onlyNumber = onlyNumber;
const nomeMask = (nome) => {
    if (!nome) {
        return '';
    }
    const preposicoes = ['das', 'da', 'de', 'do', 'dos', 'e'];
    const formataNome = (nome) => {
        const nomeLower = nome.toLowerCase();
        if (preposicoes.includes(nomeLower)) {
            return nomeLower;
        }
        return nome.charAt(0).toUpperCase() + nome.substr(1).toLowerCase();
    };
    return nome
        .split(' ')
        .map(n => formataNome(n))
        .reduce((a, b) => `${a} ${b}`);
};
exports.nomeMask = nomeMask;
//# sourceMappingURL=index.js.map